<template>
    <validation-observer #default="{ invalid }" ref="observer">
        <span class="display-none">{{ invalid }}</span>
        <b-form class="mt-4">
            <PlanInputContent
                title="D. Obiective"
            >
                <template v-slot:body>
                    <div class="yellow-warning">
                        <img src="@/assets/images/exclamation-mark-icon.png" alt="exclamation-mark-icon">
                        <div>
                            Această secțiune trebuie să definească produsul/procesul și rezultatele care urmează să fie realizate de proiect pentru a fi rentabil.
                            Obiectivele trebuie să fie clare, specifice, măsurabile, realizabile, acceptabile, realiste, legate de timp. <br><br>
                            <b>Informațiile pot fi modificate doar din pagina de <router-link to="/aplicatii/m3-sketch/obiective">Obiective</router-link>!</b>
                        </div>
                    </div>
                    <div class="textarea">
                        <validation-provider
                            #default="{ errors }"
                            rules="required"
                        >
                            <b-form-textarea
                                v-model="form.objectives"
                                rows="4"
                                max-rows="20"
                                :state="errors.length > 0 ? false : null"
                                :readonly="completed"
                            ></b-form-textarea>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </div>
                </template>
            </PlanInputContent>
            <hr class="mt-5">
            <b-form-checkbox
                v-model="completed"
                switch
                size="lg"
                class="switch-box"
                :disabled="true"
            >Informațiile sunt complete și corecte</b-form-checkbox>
        </b-form>
    </validation-observer>
</template>

<script>
    import { BForm, BFormInput, BFormCheckbox, BFormTextarea, BIconPencilSquare, BIconCheckCircleFill, BTable, BIconXCircleFill} from "bootstrap-vue";
    import PlanInputContent from '@/pages/Aplicatii/M3/M3Sketch/components/plan-afaceri/PlanInputContent'
    import { ValidationProvider, ValidationObserver } from 'vee-validate'
    import axios from '@/helpers/axios'
    import api from '@/helpers/api'
    require('@/helpers/validations/validations')
    export default {
        components: {
            BForm,
            BFormInput,
            PlanInputContent,
            BFormCheckbox,
            BFormTextarea,
            BIconPencilSquare,
            BIconCheckCircleFill,
            BTable,
            BIconXCircleFill,
            ValidationProvider, ValidationObserver
        },
        props: {
            obiective: null,
        },
        data() {
            return {
                completed: true,
                obiectiveNoi: null,
                form: {
                    objectives: null,
                }
            }
        },
        computed: {
            allData() {
                return this.$store.getters['m3Sketch/allData']
            }
        },
        mounted() {
            axios.get(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/project/objectives')
                .then(response => {
                    this.obiectiveNoi = response.data.objectives
                    let mainObjective = this.obiectiveNoi ? this.obiectiveNoi.main : '';

                    let secondaryObjectives = this.obiectiveNoi ? this.obiectiveNoi.secondary : '';

                    if(mainObjective && secondaryObjectives){
                        this.form.objectives = mainObjective.title + '\n\n' + mainObjective.content + '\n\n';

                        let i = 1;

                        secondaryObjectives.forEach(objective => {
                            if(!objective.title){
                                objective.title = '';
                            }
                            this.form.objectives = this.form.objectives + 'OS'+ i + ': '  + objective.title  + '\n\n' + objective.content + '\n\n';
                            i++;
                        })
                    }
                })


            this.$emit('formComplete')

        },
        methods: {

        }
    }
</script>

<style scoped>
.yellow-warning{
    margin-top: 10px;
    background: #ffffff;
    padding: 15px 30px;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    border:1px solid #fcefcc;
}
.yellow-warning img{
    margin-right: 20px;
}
.yellow-warning >>> *{
    font-size: 12px;
    color: #525d6e;
    margin: 0;
}
.yellow-warning >>> ul{
    list-style: inside;
}
.yellow-warning a{
    color: #8c6984;
}
.textarea{
    position: relative;
}
.textarea >>> textarea:read-only{
    background: #e5fffb;
}
.textarea >>> textarea{
    border: 2px solid #9da2b0;
    background: #f8f9f9;
    color: #515679;
}
.textarea >>> textarea:focus{
    box-shadow: 0 0 0 0.2rem #cdfaee;
}
.textarea svg{
    position: absolute;
    top: 10px;
    right: 10px;
    color: #9da2b0;
}
.switch-box{
    text-align: right;
    margin-top: 25px;
}
.switch-box >>> input, .switch-box >>> label{
    cursor: pointer;
}
.switch-box >>> label{
    font-size: 14px !important;
    color: #38393c;
    line-height: 1.9 !important;
}
</style>
